import Modal from "@/components/modal";
import { Box, Typography } from "@mui/material";
import DateRangePicker from "@/components/date-range-picker";

const DateModal = ({ open, handleClose, handleDateChange, dateState }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="date-modal-title"
      aria-describedby="date-modal-description"
      style={{ maxWidth: "fit-content" }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 2,
        }}
      >
        Choose date range
      </Typography>

      <Box sx={{ width: "100%" }}>
        <DateRangePicker onChange={handleDateChange} state={dateState} />
      </Box>
    </Modal>
  );
};

export default DateModal;
